
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import dayjs from "dayjs";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";
const finance = namespace("finance");
@Component({})
@Table("loadListData")
export default class TmallBillView extends Vue {
  @finance.Action getPaymentDetail;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  addCurrencyUnit = addCurrencyUnit;
  dayjs = dayjs;
  get breadData() {
    return [
      { name: t("finance.payment-order"), path: "/finance/payment-order" },
      { name: t("finance.bill-payment-details") }
    ];
  }
  get paymentId() {
    return this.$route.params.id;
  }
  get type() {
    // 字典值 1：采购付款 2：卡退款 9：其他
    return String(this.detailData.paymentType);
  }
  handleLinkServiceView(row) {
    let { href } = this.$router.resolve({
      path: `/purchase/purchase-view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  handleLinkCardView(row) {
    let { href } = this.$router.resolve({
      path: `/marketing/card-view/${row.cardCode}`
    });
    window.open(href, "_blank");
  }
  orderList: any[] = [];
  tableLoading: boolean = false;
  detailData: any = {};
  created() {
    this.init();
  }
  init() {
    this.loadListData();
  }
  handleLinkTmallBill(billNo) {
    let { href } = this.$router.resolve({
      path: `/finance/tmall-bill-view/${billNo}`
    });
    window.open(href, "_blank");
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.getPaymentDetail({
      paymentNo: this.paymentId,
      orderItems: this.mix_sortParams,
      pageSize: 999,
      pageNum: 1
    }).then(data => {
      this.detailData = data.data;
      this.orderList = data.data.orderList || [];
      return data;
    });
  }
}
